import { Link } from 'react-router-dom'

import { useAuth } from '../context/AuthContext.jsx'

const HOME_CARDS = [
  {
    to: '/applications',
    icon: '⚙',
    title: 'Remote Config',
    subtitle: 'Manage application configs, segments, AB tests and rules',
    permission: null,
  },
  {
    to: '/work-groups',
    icon: '👥',
    title: 'Work Groups',
    subtitle: 'Organize users and applications into groups',
    permission: 'manage_work_groups',
  },
  {
    to: '/users',
    icon: '🔑',
    title: 'Users',
    subtitle: 'Manage user accounts, roles and permissions',
    permission: 'manage_users',
  },
]

export default function HomePage() {
  const { hasPermission } = useAuth()

  const visibleCards = HOME_CARDS.filter(
    (card) => !card.permission || hasPermission(card.permission),
  )

  return (
    <div className="page">
      <div className="homeGrid">
        {visibleCards.map((card) => (
          <Link key={card.to} to={card.to} className="homeCard">
            <div className="homeCardHead">
              <span className="homeCardIcon" aria-hidden="true">{card.icon}</span>
              <span className="homeCardTitle">{card.title}</span>
            </div>
            <span className="homeCardSubtitle">{card.subtitle}</span>
          </Link>
        ))}
      </div>
    </div>
  )
}
